import { render, staticRenderFns } from "./LogOffPolicy.vue?vue&type=template&id=5e973a1f"
import script from "./LogOffPolicy.vue?vue&type=script&lang=js"
export * from "./LogOffPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports